import { AsciiText } from '../framework/AsciiText';
export class PensarLed {
    constructor(socket, log) {
        this.socket = socket;
        this.videoInput = 1;
        this.asyncHandlers = [
            {
                name: 'powerSet',
                regExp: /\x55\xAA\x00\x01\xFC\x00\x08[\x00]{3}\x01\x00([\S\s])[\x00]{3}\x01[\x00]{2}[\S\s]/,
                callback: (match) => {
                    const value = match[1].charCodeAt(0);
                    const bytes = [0, 1, 0, 0xfc, 8, 0, 0, 0, 1, 0, value, 0, 0, 0, 0, 0];
                    this.socket.send(this.makeCommand(bytes));
                },
            },
            {
                name: 'navigation',
                regExp: /\x55\xAA\x00\x01\xFC\x00\x07[\x00]{3}\x01\x00([\x01\x02\x03\x04\x08\x09\x0a\x0b\x0c])[\x00]{3}\x01\x00\x00[\S\s]/,
                callback: (match) => {
                    const value = match[1].charCodeAt(0);
                    const bytes = [0, 1, 0, 0xfc, 7, 0, 0, 0, 1, 0, value, 0, 0, 0, 0, 0, 0];
                    this.socket.send(this.makeCommand(bytes));
                },
            },
            {
                name: 'videoQuery',
                regExp: /\x55\xAA\x00\x01\xFC\x00\x06[\x00]{5}\x04[\x00]{3}\x01\x00[\S\s]/,
                callback: (match) => {
                    const bytes = [0, 1, 0, 0xfc, 6, 0, 0, 0, 0, 0, 4, 0, 0, 0, 1, 0, this.videoInput];
                    this.socket.send(this.makeCommand(bytes));
                },
            },
            {
                name: 'videoSet',
                regExp: /\x55\xAA\x00\x01\xFC\x00\x08[\x00]{3}\x01\x00\x04[\x00]{3}\x01\x00([\S\s])[\S\s]/,
                callback: (match) => {
                    this.videoInput = match[1].charCodeAt(0);
                    const bytes = [0, 1, 0, 0xfc, 8, 0, 0, 0, 1, 0, 4, 0, 0, 0, 0, 0, 0];
                    this.socket.send(this.makeCommand(bytes));
                },
            },
            {
                name: 'invalid',
                regExp: /.+/i,
                callback: (match) => {
                    this.socket.send(`error`);
                },
            },
        ];
    }
    onConfigure(config) {
        var _a;
        let lowestCode;
        for (const videoInput of Object.values((_a = config.videoInputs) !== null && _a !== void 0 ? _a : {})) {
            if (this.videoInput === parseInt(lowestCode !== null && lowestCode !== void 0 ? lowestCode : '1', 10))
                return;
            if (lowestCode === undefined ||
                parseInt(videoInput.code, 10) < parseInt(lowestCode, 10)) {
                lowestCode = videoInput.code;
            }
        }
        this.videoInput = parseInt(lowestCode !== null && lowestCode !== void 0 ? lowestCode : '1', 10);
    }
    makeCommand(command) {
        let data = [0xaa, 0x55]; // command header
        data = data.concat(command);
        let checksum = 0;
        for (const datum of data) {
            checksum += datum;
        }
        data.push((checksum - data[0]) & 0x00ff); // don't include 0xAA at index 1
        return AsciiText.decode(data);
    }
}
PensarLed.emulatorType = 'socketEmulator';
PensarLed.key = '-Mbwe5o0JJheYE8nCN4m';
